"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCalSuggestion = void 0;
const isCalSuggestion = (s) => typeof s.commands === "string";
exports.isCalSuggestion = isCalSuggestion;
//# sourceMappingURL=suggestion.js.map